import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
//import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";

//import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons components

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";

import { Typography } from "@material-ui/core";
// core components
//import AuthHeader from "components/Headers/AuthHeader.js";
//import componentStyles from "assets/theme/views/auth/register.js";
import componentStylesButtons from "assets/theme/components/button.js";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    // Add animation styles
    animation: `$sideUp 0.5s ease-out`,
    transform: "translateY(100%)",
    opacity: 0,
    animationFillMode: "forwards",
  },
  "@keyframes sideUp": {
    "0%": {
      transform: "translateY(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  cardHeader: {
    textAlign: "center",
  },
  cardContent: {
    textAlign: "center",
  },
  buttonContainedInfo: {
    backgroundColor: theme.palette.info.main,
  },
}));

const useStylesButtons = makeStyles(componentStylesButtons);

function Delete() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const theme = useTheme();
  const history = useHistory();
  const [usernames, setusernames] = useState([]);
  const [alertText, setalertText] = useState("");
  const [loading, setLoading] = useState(true);
  const [form, setform] = useState({
    username: "",
  });

  //text fields changes
  const handleChange = (e) => {
    setalertText("");
    setform((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


  const fetchUsernames = async () => {
    var token=localStorage.getItem("token")
    try {
      const res = await fetch("https://server.thelanofficial.com/Get-Users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
        }),
      });

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await res.json();

      if (data.valid === false) {
        return;
      } else if (data.valid === true) {
        setusernames(data.usernames);
        setLoading(false);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  const DeleteCLick = () => {
   
    if (["username"].some((field) => form[field] === "")) {
      setalertText("please fill all the fields");
      return;
    }

    var token = localStorage.getItem("token");

    const fetchDelete = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/Delete-User", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: form.username,
            token,
          }),
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();

        if (data.valid === false) {
          setalertText(data.message);
        } else if (data.valid === true) {

          setalertText(data.message);
          fetchUsernames();
          
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchDelete();
  };

  useEffect(() => {
    var token = localStorage.getItem("token");

    const fetchData = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/validate-token", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ token }),
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();
        if (data.valid === false) {
          history.push("/auth/login");
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchData();

    fetchUsernames();
  }, []);

  return (
    <>
      <Box component={Grid} container justifyContent="center">
        <Grid item xs={12} lg={6} md={8}>
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              title={
                <Box
                  fontSize="200%"
                  fontWeight="800"
                  component="large"
                  color={theme.palette.gray[600]}
                >
                  DELETE USER
                </Box>
              }
              titleTypographyProps={{
                component: Box,
                textAlign: "center",
                marginBottom: "1rem!important",
                marginTop: ".5rem!important",
                fontSize: "1rem!important",
              }}
            ></CardHeader>
            <CardContent classes={{ root: classes.cardContent }}>
              <Box
                color={theme.palette.gray[600]}
                textAlign="center"
                marginBottom="1.5rem"
                marginTop=".5rem"
                fontSize="1rem"
              >
                <Box fontSize="80%" fontWeight="400" component="small">
                  Delete user by selecting by username
                </Box>
              </Box>

              <FormControl variant="outlined" fullWidth>
                {loading ? (
                  <Typography>Loading...</Typography>
                ) : (
                  <Select
                    placeholder="ROLE"
                    name="username"
                    defaultValue=""
                    onChange={handleChange}
                    IconComponent={KeyboardArrowDown}
                  >
                    <MenuItem value="" disabled>
                      Select a Username
                    </MenuItem>
                    {usernames.map((username, index) => (
                      <MenuItem key={index} value={username}>
                        {username}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>

              <Box
                fontStyle="italic"
                fontSize="1rem"
                color={theme.palette.gray[600]}
                marginBottom=".5rem"
              >
                <Box component="small" fontSize="80%">
                  <Box
                    component="span"
                    fontWeight="700"
                    color={theme.palette.success.main}
                  ></Box>
                </Box>
              </Box>

              <Typography
                style={{
                  color:
                    alertText === "User deleted successfully" ? "green" : "red",
                  fontSize: "10px",
                }}
              >
                {alertText}
              </Typography>

              <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">
                <Button
                  onClick={DeleteCLick}
                  variant="contained"
                  classes={{ root: classes.buttonContainedInfo }}
                >
                  Delete User
                </Button>
              </Box>
            </CardContent>
          </Card>
          <Grid container component={Box} marginTop="1rem">
            <Grid item xs={6} component={Box} textAlign="left"></Grid>
            <Grid item xs={6} component={Box} textAlign="right"></Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Delete;
